import React, { useEffect } from 'react';
// import { GetRoutesPermissions } from '@hooks/auth';

import RouterClienteAdmin from './Cliente/AdminRouter';
import RouterClienteAdminFinanceiro from './Cliente/AdminRouterFinanceiro';
import RouterClienteAdminExpedicao from './Cliente/AdminRouterExpedicao';
import RouterClienteAdminExpedicaoFinanceiro from './Cliente/AdminRouterFinan-Exped';

import RouterAmexAdmin from './Amex/AdminRouter';
import RouterAmexOperacional from './Amex/OperacionalRouter';
import RouterClienteOperacionalFinanceiro from './Cliente/OperacionalFinanceiroRouter';
import RouterClienteOperacionalExpedicao from './Cliente/OperacionalExpedicaoRouter';
import RouterClienteOperacionalBase from './Cliente/OperacionalBaseRouter';
import RouterClienteOperacionalCoordenadorCaravana from './Cliente/OperacionalCoordenadorCaravanaRouter';


import RouteAuth from './Auth';

import { token } from '@hooks/auth';
import { useAuth } from '@hooks/AuthenticateContext';
import { getColors } from '@styles/colorsTheme';

import AdminLayout from '@layouts/Amex';
// import OperacionalLayout from '@layouts/Cliente';

import Services from '../components/Amex/SelectEntidade/services';
import { useEntidade } from '@src/hooks/EntidadeContext';
import { LoadingProvider } from '@hooks/LoadingContext';

import { Spin } from 'antd';

const DrawLayoutClienteAdmin = (Route: any) => {
  return (
    <LoadingProvider>
      <Route />
    </LoadingProvider>
  );
};

const DrawLayoutOperacional = (Route: any) => {
  return (
    <LoadingProvider>
      <Route />
    </LoadingProvider>
  );
};

const DrawLayoutAmexAdmin = (Route: any, updateEntidade: any) => {
  const [loadingEntidade, setLoadingEntidade] = React.useState(false);

  const load = async () => {
    setLoadingEntidade(true);

    const entidadeStorage = localStorage.getItem('@amex:entidade');

    if (entidadeStorage) {
      const entidadeStorageJSON = JSON.parse(entidadeStorage);

      updateEntidade(entidadeStorageJSON);
      setLoadingEntidade(false);
    } else {
      const services = new Services();
      const { error, response } = await services.getEntidades();

      if (!error && response) {
        updateEntidade({
          descricao: response[0].label,
          id: parseInt(response[0].value),
        });
        setLoadingEntidade(false);
      }
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (loadingEntidade) {
    return (
      <Spin
        size="large"
        spinning={true}
        tip={'Carregando clientes...'}
        style={{
          background: getColors()?.branco,
          width: '100%',
          height: '100%',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            background: getColors()?.branco,
            width: '100%',
            height: '100%',
            minHeight: '100vh',
          }}
        ></div>
      </Spin>
    );
  }

  return (
    <AdminLayout>
      <LoadingProvider>
        <Route />
      </LoadingProvider>
    </AdminLayout>
  );
};

const DrawLayoutAmexOperacional = (Route: any, updateEntidade: any) => {
  const [loadingEntidade, setLoadingEntidade] = React.useState(false);

  const load = async () => {
    setLoadingEntidade(true);

    const entidadeStorage = localStorage.getItem('@amex:entidade');

    if (entidadeStorage) {
      const entidadeStorageJSON = JSON.parse(entidadeStorage);

      updateEntidade(entidadeStorageJSON);
      setLoadingEntidade(false);
    } else {
      const services = new Services();
      const { error, response } = await services.getEntidades();

      if (!error && response) {
        updateEntidade({
          descricao: response[0].label,
          id: parseInt(response[0].value),
        });
        setLoadingEntidade(false);
      }
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (loadingEntidade) {
    return (
      <Spin
        size="large"
        spinning={true}
        tip={'Carregando clientes...'}
        style={{
          background: getColors()?.branco,
          width: '100%',
          height: '100%',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            background: getColors()?.branco,
            width: '100%',
            height: '100%',
            minHeight: '100vh',
          }}
        ></div>
      </Spin>
    );
  }

  return (
    <AdminLayout>
      <LoadingProvider>
        <Route />
      </LoadingProvider>
    </AdminLayout>
  );
};

function OrchestratorRoutes() {
  const { user } = useAuth();
  const { updateEntidade } = useEntidade();

  if (!!user && !!token) {
    if (user.role === 'ADM CLIENTE - GESTOR') {
      return DrawLayoutClienteAdmin(RouterClienteAdmin);
    } else if (user.role === 'ADM SOCIALLIS') {
      return DrawLayoutAmexAdmin(RouterAmexAdmin, updateEntidade);
    }  else if (user.role === 'ADM CLIENTE - FINANCEIRO'){
      return DrawLayoutClienteAdmin(RouterClienteAdminFinanceiro);
    } else if (user.role === 'ADM CLIENTE - EXPEDIÇÃO'){
      return DrawLayoutClienteAdmin(RouterClienteAdminExpedicao);
    }  else if (user.role === 'ADM CLIENTE - FINANCEIRO / EXPEDIÇÃO'){
      return DrawLayoutClienteAdmin(RouterClienteAdminExpedicaoFinanceiro);
    } else if (user.role === 'OPERACIONAL - EXPEDIÇÃO'){
      return DrawLayoutOperacional(RouterClienteOperacionalExpedicao);
    } else if (user.role === 'OPERACIONAL - FINANCEIRO'){
      return DrawLayoutOperacional(RouterClienteOperacionalFinanceiro);
    } else if (user.role === 'OPERACIONAL - BASE') {
      return DrawLayoutOperacional(RouterClienteOperacionalBase);
    } else if (user.role === 'OPERACIONAL - COORDENADOR CARAVANA') {
    return DrawLayoutOperacional(RouterClienteOperacionalCoordenadorCaravana);
  }

    return <RouteAuth />;
  } else {
    return <RouteAuth />;
  }
}

export default OrchestratorRoutes;
